<template>
  <q-dialog :visible="isVisible" :title="title" width="88%" :innerScroll="false" :showFooter="false" @close="onCancel">
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="170px" v-loading="loading" class="content">
      <el-row>
        <el-col :span="isSmall">
          <el-form-item label="产品编码:" prop="productCode">
            <span>{{ addForm.productCode }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="台面材质:" prop="tableTextureType">
            <span>{{ addForm.tableTextureType }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="床垫软硬度:" prop="mattressHardnessType">
            <span>{{ addForm.mattressHardnessType }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="茶几抽屉类型:" prop="teapoyDrawerType">
            <span>{{ addForm.teapoyDrawerType }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="主色编码:" prop="mainColorCode">
            <span>{{ addForm.mainColorCode }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="配色:" prop="matchColor">
            <span>{{ addForm.matchColor }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="内堂颜色:" prop="boreColor">
            <span>{{ addForm.boreColor }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="直径:" prop="diameter">
            <span>{{ addForm.diameter }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="长(外观):" prop="length">
            <span>{{ addForm.length }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="宽(外观):" prop="width">
            <span>{{ addForm.width }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="高(外观):" prop="height">
            <span>{{ addForm.height }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="外观尺寸:" prop="exteriorSize">
            <el-tooltip
              class="item"
              effect="dark"
              :content="addForm.exteriorSize"
              placement="top-start"
              v-if="addForm.exteriorSize && addForm.exteriorSize.length >= 13"
            >
              <div class="textTips">{{ addForm.exteriorSize || '' }}</div>
            </el-tooltip>
            <div class="textTips" v-else>{{ addForm.exteriorSize || '' }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="材质类型名称:" prop="productTextureTypeName">
            <span>{{ addForm.productTextureTypeName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="主要材质:" prop="mainTexture">
            <span>{{ addForm.mainTexture }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="款式:" prop="design">
            <span>{{ addForm.design }}</span>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="最高可配床垫高度:" prop="mattressThckRef">
            <span>{{ addForm.mattressThckRef }}</span>
          </el-form-item>
        </el-col> -->
        <el-col :span="isSmall">
          <el-form-item label="功能描述:" prop="functionDescription">
            <el-tooltip
              class="item"
              effect="dark"
              :content="addForm.functionDescription"
              placement="top-start"
              v-if="addForm.functionDescription && addForm.functionDescription.length >= 13"
            >
              <div class="textTips">{{ addForm.functionDescription || '' }}</div>
            </el-tooltip>
            <div class="textTips" v-else>{{ addForm.functionDescription || '' }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="拆洗类型:" prop="dismantleWashType">
            <span>{{ addForm.dismantleWashType }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isSmall">
          <el-form-item label="拆洗描述:" prop="dismantleWashDesc">
            <el-tooltip
              class="item"
              effect="dark"
              :content="addForm.dismantleWashDesc"
              placement="top-start"
              v-if="addForm.dismantleWashDesc && addForm.dismantleWashDesc.length >= 13"
            >
              <div class="textTips">{{ addForm.dismantleWashDesc || '' }}</div>
            </el-tooltip>
            <div class="textTips" v-else>{{ addForm.dismantleWashDesc || '' }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="item.label.length < 9 ? isSmall : 8" v-for="item in dynamicItem" :key="item.label">
          <el-form-item :label="`${item.label}:`" prop="exteriorSize">
            <el-tooltip class="item" effect="dark" :content="item.value" placement="top-start" v-if="item.value && item.value.length >= 13">
              <div class="textTips">{{ item.value || '' }}</div>
            </el-tooltip>
            <div class="textTips" v-else>{{ item.value || '' }}</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footer">
      <el-button type="primary" @click="onCancel">关闭</el-button>
    </div>
  </q-dialog>
</template>

<script>
import moment from 'moment';
import axios from '@/utils/axiosInstance';
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
    storeCode: String,
    reportMonthCode: String,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return 'DOM产品信息';
    },
    name() {
      return this.$store.state.user.name;
    },
    isSmall() {
      return window.innerWidth < 1920 ? 8 : 6;
    }
  },
  data() {
    return {
      loading: false,
      addForm: {},
      rules: {
        // reportNum: [
        //   { required: true, message: '请输入提报数量', trigger: 'blur' }
        // ],
      },
      dynamicItem: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    async init() {
      this.loading = true;
      const form = new FormData();
      form.append('productCode', this.rowData.productCode);
      this.$q.product
        .queryProductAttrInfos({ data: form })
        .then(({ data }) => {
          this.dynamicItem = [];
          let { attrList, valueList } = data;
          attrList.forEach((v, index) => {
            this.dynamicItem.push({
              label: v,
              value: valueList[index],
            });
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    console.log(this.innerWidth);
    if (this.rowData) {
      this.addForm = this.rowData;
      this.init();
    }
  },
};
</script>

<style lang="stylus" scoped>
.content {
  max-height: 68vh
  overflow-y: auto
}
.footer {
  padding: 30px 0 10px 0
  text-align: center
}
 .textTips {
  cursor: pointer
  height: 40px
  overflow: hidden
  white-space: nowrap;
  text-overflow: ellipsis
}
>>> .el-dialog{
  margin-top: 50px !important;
}
</style>
